// @ts-check
/** @jsxRuntime classic */
/** @jsx jsx */
import BaseBrandLogo from '@bottlebooks/gatsby-theme-event/src/components/Brand/BrandLogo';
import { jsx } from 'theme-ui';

export * from '@bottlebooks/gatsby-theme-event/src/components/Brand/BrandLogo';

/**
 * @param {React.ComponentPropsWithoutRef<typeof BaseBrandLogo> & {
 *  brand: {
 *    logo?: {
 *      publicId?: string | null;
 *      fixed?: { src: string; } | null
 *    }
 *  } | null;
 *  onDark: boolean
 * }} props
 */
export default function BrandLogo(props) {
  if (props.brand?.logo?.publicId) return <BaseBrandLogo {...props} />;
  if (props.brand?.logo?.fixed?.src) return <BaseBrandLogo {...props} />;
  return (
    <BaseBrandLogo
      {...props}
      brand={{
        ...props.brand,
        logo: {
          ...props.brand,
          publicId:
            'bottlebooks/5a16e716c93586389fd8e9e6/Wein_Burgenland-VieVinum-Test-eventLogo-VieVinum-Logo-3327.png',
        },
      }}
    />
  );
}
